import type { Stock, User } from '@/types/model'
import { setupApp } from '@/globals/app.ts'
import type { ParseData, InputLabelValue, ResAxios, TableData, ContentData } from '@/types'
import { useStockStore } from '@/stores/app/stock.store'
import type { Router } from 'vue-router'
import { useModalStore } from '@/stores/modal.store.ts'
import type { ColorKey } from '@/types/tailwind'

type TypeData = 'data' | 'create' | 'edit'

export const iconStockType: string[] = ['box-arrow-up', 'box-arrow-down']
export const colorStockType: ColorKey[] = ['red', 'green']
export const labelStockType: string[] = ['Out', 'In']

export const parseDataStock = async (
  type: TypeData,
  id: number = 0,
  query: string = '',
): Promise<ParseData<Stock> | null> => {
  const { loadStock, loadStockCreate, loadStockData } = useStockStore()

  // dapatkan data dari mana
  const action: Record<TypeData, () => Promise<ResAxios<Stock>>> = {
    data: () => loadStock(query),
    create: () => loadStockCreate(),
    edit: () => loadStockData(id),
  }

  // res
  const res = await action[type]()

  // jika sukses
  if (res.data.status === 'success') {
    // simplify
    const resDataUser = res.data.user as User
    const content = (res.data.content as ContentData) ?? null
    const data = res.data.data
      ? type === 'data'
        ? (res.data.data as TableData<Stock>)
        : (res.data.data as Stock)
      : null

    // setup app
    setupApp(resDataUser)

    // branch service
    const resDataSuppliers = res.data.suppliers

    // categories
    const categories = res.data.categories ?? undefined

    // suppliers
    const suppliers = resDataSuppliers
      ? (resDataSuppliers.map((supplier) => ({
          value: supplier.id,
          label: supplier.name,
        })) as InputLabelValue[])
      : null

    // stock lists
    const stockLists = { suppliers }

    return {
      data,
      content,
      categories,
      stockLists,
    }
  }

  return null
}

export const sendDataStock = async (
  type: TypeData,
  form: Stock,
  router: Router,
  onRefresh?: () => void,
): Promise<void | Record<string, string[]> | null> => {
  const { addStock, editStock } = useStockStore()
  const { showModal } = useModalStore()

  const res = type === 'create' ? await addStock(form) : await editStock(form)

  showModal(res.data.status, res.data.message, res.data.status)

  if (res.data.status === 'success') {
    if (type === 'edit' && onRefresh) {
      onRefresh()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      const stockId: number = res.data.data.id as number
      if (
        router.currentRoute.value.name === 'stock-edit' &&
        router.currentRoute.value.params.id == String(stockId)
      ) {
        await router.push({ name: 'stock-edit', params: { id: stockId } }).then(() => {
          window.location.reload()
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
      } else {
        await router.push({ name: 'stock-edit', params: { id: stockId } })
      }
    }
  }

  if (res.data.status === 'error') {
    return res.data.errors as Record<string, string[]> | null
  }
}
